<template>
  <form-dialog
    visible
    :pending="pending"
    :errors="errors"
    :title="$t('Change language')"
    :applyButtonText="$t('Save')"
    class="user-change-language"
    :submit="onSubmit"
    @close="close"
  >
    <el-table
      row-key="language"
      background-color="solid-brand-lightest"
      :show-header="false"
      :data="languages"
      :highlight-current-row="true"
      @row-click="onRowClick"
    >
      <el-table-column>
        <template #default="{ row }">
          <el-radio
            v-model="selectedLocale"
            class="mr-16"
            :label="row.language"
          />
          {{ row.display_name }}
        </template>
      </el-table-column>
    </el-table>
  </form-dialog>
</template>

<script>
  import FormDialog from '@/common/shared/FormDialog.vue';
  import i18n from '@/common/i18n';
  import { mapState, mapStores } from 'pinia';
  import useI18nStore from '@/common/store/pinia/i18n';

  export default {
    name: 'UserChangeLanguage',
    components: {
      FormDialog
    },
    data() {
      return {
        selectedLocale: null,
        pending: false,
        errors: [],
      };
    },
    created() {
      this.selectedLocale = this.currentLocale;
    },
    computed: {
      ...mapStores(useI18nStore),
      ...mapState(useI18nStore, ['languages']),
      currentLocale() {
        return i18n.locale;
      }
    },
    watch: {
      currentLocale(value) {
        this.selectedLocale = value;
      }
    },
    methods: {
      onSubmit() {
        this.pending = true;
        this.errors = [];
        return this.i18nStore.loadLanguage(this.selectedLocale)
          .then(() => {
            this.pending = false;
            this.$emit('close');
          })
          .catch((err) => {
            this.pending = false;
            this.errors = [err.message];
          });
      },
      close() {
        this.$emit('close');
      },
      onRowClick({ language }) {
        this.selectedLocale = language;
      }
    }
  };
</script>
